import { actions } from "../../../actions/training/webinars/webinars";

export default function webinars( state = {}, action ) {

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_CURRENT_WEBINAR: return setCurrentWebinar( newState, action.webinar );
        case actions.SET_WEBINARS: return setWebinars( newState, action );
        case actions.SET_WEBINAR_LOCATIONS: return setWebinarLocations( newState, action.locations );
        case actions.SET_CURRENT_WEBINAR_MODULES: return setCurrentWebinarModules( newState, action.modules );
        default: return state;
    }
}

function setCurrentWebinar( newState, webinar ) {
    newState.current_webinar = webinar;

    return newState;
}

function setCurrentWebinarModules( newState, modules ) {
    newState.current_webinar_modules = modules;

    return newState;
}

function setWebinars( newState, action ) {
    newState.webinars = action.webinars;
    newState.pagination = action.pagination;

    return newState;
}

function setWebinarLocations( newState, locations ) {
    newState.locations = locations;

    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/training/webinars/webinars.js